import React, { Component, createRef } from 'react';
import { bool, array, string, func } from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './Dropdown.css';

class Dropdown extends Component {
  static propTypes = {
    emptyState: string,
    className: string,
    opts: array.isRequired,
    disabled: bool,
    autoWidth: bool,
    onChange: func,
  };

  static defaultProps = {
    opts: [],
    autoWidth: true
  };

  dropdownRef = createRef();
  selectedMeterRef = createRef();

  opts = this.props.emptyState ?
    [{ label: this.props.emptyState, value: '' }, ...this.props.opts] :
    this.props.opts;

  state = {
    selectedOption: this.opts[0],
    dropdownWidth: null
  };

  componentDidMount = () => {
    const { autoWidth } = this.props;

    if (autoWidth) {
      this.setState({
        dropdownWidth: this.getSelectedValueWidth()
      });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { autoWidth } = this.props;
    const newWidth = this.getSelectedValueWidth();

    if (autoWidth && prevState.dropdownWidth !== newWidth) {
      this.setState({ dropdownWidth: newWidth });
    }
  }

  handleChange = () => {
    const { onChange } = this.props;
    const selectedValue = this.opts.find(option => option.value === this.getSelectedValue());

    this.setState({
      selectedOption: selectedValue
    });

    onChange && onChange(selectedValue);
  }

  getSelectedValueWidth = () => {
    return this.selectedMeterRef.current.getClientRects()[0].width + 20;
  }

  getSelectedValue = () => {
    return this.dropdownRef.current.value;
  }

  renderSelectOptions = () => (
    this.opts.map(opt =>
      <option key={`option-${opt.value}`} value={opt.value}>
        {opt.label}
      </option>
    )
  );

  render() {
    const { disabled, className, autoWidth } = this.props;
    const { selectedOption, dropdownWidth } = this.state;

    const calculatedDropdownWidth = autoWidth && dropdownWidth
      ? dropdownWidth + 'px'
      : 'auto';

    // Styles
    const cx = classnames.bind(styles);

    const inputFieldClasses = cx(styles.inputField, className, { disabled });

    const selectClasses = cx(styles.select, { isSelected: selectedOption > 0 });

    const selectProps = {
      disabled,
      ref: this.dropdownRef,
      className: selectClasses,
      onChange: this.handleChange
    };

    return (
      <div style={{ width: calculatedDropdownWidth }} className={inputFieldClasses}>

        <select {...selectProps}>
          { this.renderSelectOptions() }
        </select>

        <Icon icon="chevron-down" type="15" />

        <div ref={this.selectedMeterRef} className={classnames(styles.select, styles.selectedMeter)}>
          { selectedOption.label }
        </div>
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/inputs/Dropdown/Dropdown.js